// extracted by mini-css-extract-plugin
export var closeButton = "_8-1";
export var container = "_8-0";
export var fullModalImage = "_8-2";